import React, { useState, useEffect } from "react";
import { graphql } from "gatsby"
import Modal from "react-bootstrap/Modal"
import { Helmet } from "react-helmet"
import PropertyNav from "../components/PropertyDetails/PropertyNav";
import StickyNav from "../components/PropertyDetails/StickyNav/StickyNav"
import BannerBottom from "../components/SearchListing/BannerBottom"
import Avenue from "../components/PropertyDetails/Avenue/Avenue";
import Description from "../components/PropertyDetails/PropertyDescription/Description";
import Connect from "../components/PropertyDetails/Connect/Connect";
import SimilarProperties from "../components/PropertyDetails/SimilarProperties/SimilarProperties";
import LocRatingMap from "../components/map/loc-rating-map-details"
import BrandLogo from "../images/logo002.svg";
import MemberForm from "../components/forms/member-form"
import Layout from "../components/layout";
import SEO from "../components/seo";
import { propertyDetH1, propertyDetDesc, propertyDetImage } from "../components/property-search/propertyDetailsSEO";
import ContactStickyNav from "../components/PropertyDetails/StickyNav/ContactStickyNav";
import EnquirySticky from "../components/PropertyDetails/StickyNav/EnquirySticky";
import NotFoundPage from "../pages/404";
import ContactVendor from "../components/PropertyDetails/ContactVendor/ContactVendor";

export const query = graphql`
  query {
    glstrapi {
      globalModule {
        Auction_Details {
          Joint_Auctioneer
          Make_An_Offer
          Notice_Bidder_Content
          Purchase_Legal_Summary
          Register_To_Bid
          View_Legal_Documents
        }
      }
    }
  }
`;

const AuctionPropertyDetailsTemplate = ({ pageContext, data, location }) => {
    const property_data = pageContext.data;
    const prevProperty = pageContext.prevProperty;
    const nextProperty = pageContext.nextProperty;
    const negotiatorData = pageContext.negotiatorData;
    const isDepartmentView = pageContext?.isDepartmentView || false;
    const raw_global_module = data?.glstrapi?.globalModule?.Auction_Details;
    const global_module = raw_global_module ? {
        ...raw_global_module,
        Joint_Auctioneer: Array.isArray(raw_global_module.Joint_Auctioneer?.data)
            ? raw_global_module.Joint_Auctioneer.data
            : [],
    } : null;
    const [search, setSearch] = useState(false);
    const [open, setOpen] = useState(false);
    const [menu_heading, setMenuHeading] = useState(false);
    const [state, setState] = React.useState({
        showMenu: false,
    });
    const [isOpen, setIsOpen] = useState(false);
    const [membDet, setMembDet] = useState('');
    const [popupType, setPopupType] = useState('');
    const MemberPopup = (item, popupType) => {
        setPopupType(popupType);
        setMembDet(item);
        setIsOpen(true);
    }


    useEffect(() => {
        if (typeof window !== "undefined") {
            document.body.classList.remove("overflow-hidden");
        }
    }, []);



    if (!property_data) {
        return (<NotFoundPage />)
    }

    // Header handle click
    const handlerClick = () => {
        setState({ ...state, showMenu: !state.showMenu });
        if (typeof window !== "undefined") {
            if (state.showMenu === true) {
                document.body.className = "";
            } else {
                document.body.classList.add("overflow-hidden");
            }
        }
    };

    const openHam = () => {
        setOpen(!open);
    };

    const openSearch = (menu_title) => {
        setSearch(!search);
        handlerClick();
        setMenuHeading(menu_title)
    };
    const closeSearch = () => {
        setSearch(!search);
        handlerClick();
    };

    var lot_no = location?.state?.lot_no || "";
    var page_url = location?.state?.page_url || "";

    var pop_slug = "auctions";

    // Use SSR-provided single property object for meta
    var meta_title = propertyDetH1(property_data);
    var meta_desc = propertyDetDesc(property_data);
    var meta_img = propertyDetImage(property_data);

    // Get Map Details
    let mapItems = [];
    let mapItem = {};
    mapItem['lat'] = property_data.latitude
    mapItem['lng'] = property_data.longitude
    mapItem['id'] = property_data.id
    mapItems.push(mapItem);

    var area = property_data.address?.address3 ? property_data.address?.address3 : property_data.address?.address2 ? property_data.address?.address2 : property_data.address?.address1;

    return (
        <Layout GQLPage="" Layout="Without_Banner" classNames={`search-header person-header details-header ${pop_slug && `${pop_slug}-prop-details`}`} closeSearch={closeSearch} handlerClick={handlerClick} menu_heading={menu_heading} search={search} open={open} popular_search_slug={pop_slug}>

            <Helmet>
                <title>{meta_title}</title>
                <meta name="description" content={meta_desc} />
                <meta property="og:image" content={meta_img} />
                <script async src="https://www.googletagmanager.com/gtag/js?id=AW-10810490027"></script>
            </Helmet>
            <SEO title={meta_title} description={meta_desc} image={meta_img} />
            <BannerBottom />
            <PropertyNav propertyData={property_data} page_url={page_url} />                           
            <StickyNav propertyData={property_data} />
            <ContactStickyNav propertyData={property_data} />
            <Avenue propertyData={property_data} lot_no={lot_no} globalModule={global_module} prevProperty={prevProperty} nextProperty={nextProperty} negotiatorData={negotiatorData} />
            <ContactVendor propertyVendor={property_data?.extra?.contacts} />
            <Description propertyData={property_data} globalModule={global_module} negotiatorData={negotiatorData} />
            <div className="property-details-landing-map mt-5" id="property-details-map">
                <LocRatingMap data={mapItems} sold_price_tab={false} />
            </div>

            {property_data?.status?.toLowerCase() !== "sold" && property_data?.status?.toLowerCase() !== "let" &&
                <Connect propertyData={property_data} openSearch={openSearch} openHam={openHam} search={search} open={open} location={location} globalModule={global_module} />
            }
            <SimilarProperties propertyData={property_data} area={area} department={property_data.department} MemberPopup={MemberPopup} />
            <EnquirySticky />

            {
                popupType &&
                <Modal
                    id="popup_modal_form"
                    show={isOpen}
                    onHide={() => setIsOpen(false)}
                    backdrop="static"
                    keyboard={false}
                    className="member-contact-modal"
                >
                    {
                        popupType === "Member_Form" && <>
                            <Modal.Header closeButton className="contact-close-btn memberPopup">
                                <Modal.Title className="w-100"><h3 className="text-center content-primary-color mb-0">Contact - {membDet.Name}</h3></Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <MemberForm to_email_id={membDet.Email_ID} to_user_id={membDet.Form_Queue_ID} formName={`Individual Contact - ${membDet.Name}`} formLabel={`Person ${membDet.Name}`} />
                            </Modal.Body>
                        </>
                    }
                </Modal>
            }
        </Layout>
    )
}

export default AuctionPropertyDetailsTemplate
